import CryptoJS from 'crypto-js'

// 与后端 DESUtil.KEY_STR 一致，DES 仅使用前 8 字节
const DES_KEY = CryptoJS.enc.Utf8.parse('zzbrTTA&')

export function encryptPassword(password) {
  if (!password) {
    return ''
  }
  const encrypted = CryptoJS.DES.encrypt(CryptoJS.enc.Utf8.parse(password), DES_KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}



// WEBPACK FOOTER //
// ./src/utils/passwordEncrypt.js